<!-- 获取单个停车场空车位接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <!-- <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre> -->
            <!-- <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre> -->
        </right-structure>
    </div>
</template>

<script>
import structure from "../appendixStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            infoData: {
                payMethod: [{
                    titleName: null,
                    tabledata: [{ tableHead: '值', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        { info1: '0', info2: '未知' },
                        { info1: '1', info2: '现金' },
                        { info1: '2', info2: '自发卡' },
                        { info1: '3', info2: '次数' },
                        { info1: '4', info2: '微信支付' },
                        { info1: '5', info2: '支付宝支付' },
                        { info1: '6', info2: '银联闪付' },
                        { info1: '7', info2: '交通卡' },
                        { info1: '8', info2: '免费' },
                        { info1: '9', info2: '优惠' },
                        { info1: '10', info2: '银联接触卡' },
                        { info1: '11', info2: '银联网络支付' },
                        { info1: '12', info2: '第三方余额' },
                        { info1: '13', info2: 'NFC' },
                        { info1: '14', info2: '普通储蓄卡' },
                        { info1: '15', info2: '信用卡' },
                        { info1: '16', info2: '微信免密' },
                        { info1: '17', info2: '支付宝免密' },
                        { info1: '18', info2: '腾讯无感支付' },
                        { info1: '19', info2: 'ETC' },
                        { info1: '20', info2: '手动转账' },
                        { info1: '21', info2: '微信无感支付' },
                        { info1: '22', info2: '支付宝无感支付' },
                        { info1: '23', info2: '银联无感支付' },
                        { info1: '24', info2: '转账（仅适用于线上月票）' },
                        { info1: '25', info2: '刷卡（仅适用于线上月票）' }
                        ]
                }],
                payOrigin: [{
                    titleName: null,
                    tabledata: [{ tableHead: '值', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        { info1: '0', info2: '未知' },
                        { info1: '1', info2: '出入口（岗亭）' },
                        { info1: '2', info2: '中央缴费' },
                        { info1: '3', info2: '自助缴费机' },
                        { info1: '4', info2: '平板' },
                        { info1: '5', info2: '移动POS机' },
                        { info1: '6', info2: '移动APP' },
                        { info1: '7', info2: '微信服务号' },
                        { info1: '8', info2: '支付宝服务窗' },
                        { info1: '9', info2: '线上支付（无感支付）' },
                        { info1: '10', info2: '独立H5' },
                        { info1: '11', info2: 'POMP' },
                        { info1: '12', info2: 'VEMS' },
                        { info1: '13', info2: 'AOMP' },
                        { info1: '14', info2: '微信小程序' },
                        { info1: '15', info2: '支付宝小程序' }
                        ]
                }],
                inOut_in: [{
                    titleName: null,
                    tabledata: [{ tableHead: '值', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }, { tableHead: '场景描述', tdName: 'info3' }],
                    td: [
                        { info1: '0', info2: '未知', info3: '没有定义的场景可以暂时用此状态'},
                        { info1: '1', info2: '正常', info3: '车辆正常进' },
                        { info1: '2', info2: 'VIP转临时车', info3: '多位多车时VIP车辆转成临时车辆进场' },
                        { info1: '3', info2: '没有通道权限' , info3: '是VIP但没有当前通道权限'},
                        { info1: '4', info2: '访客' , info3: '访客进场'},
                        { info1: '5', info2: '黑名单' , info3: '黑名单进场'},
                        { info1: '6', info2: '红名单', info3: '红名单进场' },
                        { info1: '7', info2: 'ETC', info3: 'ETC车辆进场' },
                        { info1: '8', info2: '高峰' , info3: '高峰模式下进场'},
                        { info1: '9', info2: '常开' , info3: '常开模式下进场'},
                        { info1: '10', info2: 'VIP满位转临时车', info3: 'VIP满位时转成临时车进场' },
                        { info1: '11', info2: '多位多车判定失败', info3: '请求服务器失败，多位多车按VIP进场' },
                        { info1: '12', info2: '次数VIP耗尽', info3: '次数VIP多位多车时，多车共享次数，次数耗尽' }
                        ]
                }],
                inOut_out: [{
                    titleName: null,
                    tabledata: [{ tableHead: '值', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }, { tableHead: '场景描述', tdName: 'info3' }],
                    td: [
                        { info1: '0', info2: '未知' , info3: '没有定义的场景可以暂时用此状态'},
                        { info1: '1', info2: '正常' , info3: '车辆正常出'},
                        { info1: '2', info2: 'VIP转临时车' , info3: '多位多车时VIP车辆转成临时车辆出场'},
                        { info1: '3', info2: '没有通道权限', info3: '是VIP但没有当前通道权' },
                        { info1: '4', info2: '在场转临时车', info3: '进场时候是VIP，离场时VIP失效' },
                        { info1: '5', info2: '在场转VIP车' , info3: '进场时是临时车，离场时是VIP'},
                        { info1: '6', info2: '访客转临时车', info3: '进场是访客，离场时失效' },
                        { info1: '7', info2: '临时车成了访客', info3: '在场时不是访客，离场时是访客' },
                        { info1: '8', info2: '黑名单转成非黑名单' , info3: '黑名单进场，离场时不是黑名单'},
                        { info1: '9', info2: '非黑名单转成黑名单' , info3: '在场时不是黑名单，离场时是黑名单'},
                        { info1: '10', info2: '红名单转成非红名单', info3: '进场是红名单，离场时不是' },
                        { info1: '11', info2: '非红名单转成红名单', info3: '进场不是红名单，离场时是红名单' },
                        { info1: '12', info2: '进场无通道权限VIP转临时车', info3: '进场无通道权限，离场有通道权限' },
                        { info1: '13', info2: '共享车辆超时离场' , info3: '共享超时'},
                        { info1: '14', info2: 'ETC', info3: 'ETC车辆离场' },
                        { info1: '15', info2: '高峰' , info3: '高峰模式下离场'},
                        { info1: '16', info2: '常开' , info3: '常开模式下离场'},
                        { info1: '17', info2: 'VIP满位转临时车' , info3: 'VIP满位时转成临时车出场'},
                        { info1: '97', info2: '同车再次出场' , info3: '同车再次出场'},
                        { info1: '99', info2: '离场无在场记录' , info3: '离场无在场记录'},

                        ]
                }],
                vipType: [{
                    titleName: null,
                    tabledata: [{ tableHead: '值', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        { info1: '0', info2: '未知' },
                        { info1: '1', info2: '临时车' },
                        { info1: '2', info2: '本地VIP，包括时间类型、储值类型、计次类型' },
                        { info1: '3', info2: '外部VIP（已废弃）' },
                        { info1: '4', info2: '黑名单' },
                        { info1: '5', info2: '访客' },
                        { info1: '6', info2: '预定车位车辆' },
                        { info1: '7', info2: '共享车位车辆' },
                        { info1: '8', info2: '红名单' }
                        ]
                }],
                enterLeaveType: [{
                    titleName: null,
                    tabledata: [{ tableHead: '值', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        { info1: '0', info2: '未知' },
                        { info1: '1', info2: '自动放行' },
                        { info1: '2', info2: '确认放行' },
                        { info1: '3', info2: '异常放行' },
                        { info1: '4', info2: '遥控开闸' },
                        { info1: '5', info2: '自助开闸' },
                        { info1: '6', info2: '可疑跟车' },
                        { info1: '7', info2: '盘点进场(补录)' },
                        { info1: '8', info2: '离线自动放行' },
                        { info1: '9', info2: '离线遥控放行' },
                        { info1: '11', info2: '欠费放行' },
                        { info1: '12', info2: '同车再次出场' },
                        { info1: '13', info2: '离场无在场记录' },
                        { info1: '14', info2: '补录进场' },
                        { info1: '15', info2: '常开模式' },
                        { info1: '16', info2: '高峰模式' },
                        { info1: '97', info2: '重复进场在场车辆强制离场' },
                        { info1: '98', info2: '盘点离场' },
                        { info1: '99', info2: '虚拟放行' },
                        { info1: '100', info2: '虚拟放行' }
                        ]
                }]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/appendixData.vue